import { Text, styled } from '@grupoboticario/flora-react';
import React from 'react';
import { IProduct } from 'src/common/types/CatalogType';
interface IProductDescription extends Pick<IProduct, 'description'> {} //NOSONAR

const Styled = {
  ContainerDescription: styled('div', {
    marginTop: '$4',
  }),
};

const ProductDescription = ({
  description,
}: IProductDescription): JSX.Element => {
  return (
    <Styled.ContainerDescription className="ProductDescription">
      <Text
        size="auxiliarSmall"
        data-testid="product-description"
        dangerouslySetInnerHTML={{ __html: description }}
        as="div"
        css={{
          marginTop: '$4',
          fontFamily: '$primary',
        }}
      />
    </Styled.ContainerDescription>
  );
};

export default ProductDescription;
